import { hoursAgo } from '../operationalIntelligence/intelligenceHeuristics';
import type { AdaptiveExecutionState } from './types';

export const RECOVERY_CONTROLLED_WAIT_HOURS = 6;
export const RECOVERY_STABILIZE_ACTIVITY_HOURS = 2;

const ADAPTIVE_LABELS: Record<AdaptiveExecutionState, string> = {
  NORMAL: 'Нормальное исполнение',
  DELAYED_BUT_CONTROLLED: 'Задержка под контролем',
  RECOVERY_IN_PROGRESS: 'Восстановление в процессе',
  STABILIZING: 'Стабилизация',
  DEGRADED: 'Деградация исполнения',
  CRITICAL_RECOVERY: 'Критическое восстановление'
};

export function adaptiveStateLabel(state: AdaptiveExecutionState): string {
  return ADAPTIVE_LABELS[state] ?? state;
}

export function hasRecentActivity(
  stopTimestamps: Array<string | null | undefined>,
  now: Date,
  withinHours: number
): boolean {
  for (const iso of stopTimestamps) {
    const h = hoursAgo(iso, now);
    if (h != null && h <= withinHours) return true;
  }
  return false;
}
